import { FetchOptions } from '../types';

export type HttpClient = (options: FetchOptions) => Promise<Response>;

export async function httpClient({
  url,
  ...options
}: FetchOptions): Promise<Response | undefined> {
  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      return undefined;
    }
    return response;
  } catch(e) {
    // swallow SDK errors to prevent client from crashing
    return undefined;
  }
}

const NUMBER_OF_RETRIES = 3;

export async function retryRequest(request: () => Promise<Response | undefined>) {
  for (let i = 0; i < NUMBER_OF_RETRIES; i++) {
    const response = await request();
    if (response?.ok) {
      return response;
    }
  }

  return undefined;
}

export const retryPost = retryRequest;

export function isURL(value: unknown): boolean {
  if (typeof value !== 'string') {
    return false;
  }
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
}
